module.exports = __webpack_public_path__ + "img/pay-as-you-go.af8f2852.svg";